import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/image/268VIcon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-0e25a1fa")

_pushScopeId("data-v-0e25a1fa")
const _hoisted_1 = { class: "ui__headTip_main" }
const _hoisted_2 = {
  class: "ui__head_content",
  id: "headMainTop"
}
const _hoisted_3 = { class: "ui__headTip_content_report" }
const _hoisted_4 = {
  key: 0,
  class: "logo-icon"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "localIcon",
  src: _imports_0
}, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "logo-icon"
}
const _hoisted_7 = { class: "ui__headTip_content_report_text" }
const _hoisted_8 = { class: "ui__headTip_content_report_num" }
const _hoisted_9 = { class: "ui__headTip_content_result" }
const _hoisted_10 = { class: "ui__headTip_content_result_title" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 此车已经过专业认证机构检测认证 ")
const _hoisted_12 = { class: "ui__headTip_content_result_flexbox" }
const _hoisted_13 = { class: "ui__headTip_content_result_item" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", null, " 非重大事故车 ", -1)
const _hoisted_15 = { class: "ui__headTip_content_result_item" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", null, " 非火烧车 ", -1)
const _hoisted_17 = { class: "ui__headTip_content_result_item" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", null, " 非泡水车 ", -1)
const _hoisted_19 = { class: "ui__headTip_content_result_item" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("非重大事故车 ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("重大事故车 ")
const _hoisted_22 = { class: "ui__headTip_content_result_item" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("非火烧车 ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("火烧车 ")
const _hoisted_25 = { class: "ui__headTip_content_result_item" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("非泡水车 ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("泡水车 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_componentModel = _resolveComponent("componentModel")

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.state.channelType !== 'lingshou')
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _hoisted_5
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode("img", {
                class: "lingshou",
                src: _ctx.state.logoUrl
              }, null, 8, ["src"])
            ])),
        _createVNode("div", _hoisted_7, " 检测" + _toDisplayString(_ctx.state.reportLevel === 32 ? '质保双' : '') + "认证评估报告 ", 1),
        _createVNode("div", _hoisted_8, " NO. " + _toDisplayString(_ctx.state.reportCode), 1)
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("img", {
            src: require('@/assets/image/passIcon.png')
          }, null, 8, ["src"]),
          (_ctx.state.channelType === 'lingshou')
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _hoisted_11
              ], 64))
            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                (_ctx.state.point === 'N')
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("此车已通过268V买车无忧" + _toDisplayString(_ctx.state.reportLevel === 32 ? '双' :'检') + "认证", 1)
                    ], 64))
                  : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("此车已经过买车无忧" + _toDisplayString(_ctx.state.reportLevel === 32 ? '双' :'检') + "认证", 1)
                    ], 64))
              ], 64))
        ]),
        _createVNode("div", _hoisted_12, [
          (_ctx.state.point === 'N')
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("img", {
                    src: require('@/assets/image/noAccidentCar.png')
                  }, null, 8, ["src"]),
                  _hoisted_14
                ]),
                _createVNode("div", _hoisted_15, [
                  _createVNode("img", {
                    src: require('@/assets/image/noFireCar.png')
                  }, null, 8, ["src"]),
                  _hoisted_16
                ]),
                _createVNode("div", _hoisted_17, [
                  _createVNode("img", {
                    src: require('@/assets/image/noWaterCar.png')
                  }, null, 8, ["src"]),
                  _hoisted_18
                ])
              ], 64))
            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _createVNode("div", _hoisted_19, [
                  (!_ctx.state.isAccident)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _createVNode("img", {
                          src: require('@/assets/image/noAccidentCar.png')
                        }, null, 8, ["src"]),
                        _createVNode("div", null, [
                          _createVNode("img", {
                            src: require('@/assets/image/unionIcon.png')
                          }, null, 8, ["src"]),
                          _hoisted_20
                        ])
                      ], 64))
                    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        _createVNode("img", {
                          src: require('@/assets/image/accidentCar.png')
                        }, null, 8, ["src"]),
                        _createVNode("div", null, [
                          _createVNode("img", {
                            src: require('@/assets/image/unionIcon.png'),
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleClick('major')))
                          }, null, 8, ["src"]),
                          _hoisted_21
                        ])
                      ], 64))
                ]),
                _createVNode("div", _hoisted_22, [
                  (!_ctx.state.isFire)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _createVNode("img", {
                          src: require('@/assets/image/noFireCar.png')
                        }, null, 8, ["src"]),
                        _createVNode("div", null, [
                          _createVNode("img", {
                            src: require('@/assets/image/unionIcon.png')
                          }, null, 8, ["src"]),
                          _hoisted_23
                        ])
                      ], 64))
                    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        _createVNode("img", {
                          src: require('@/assets/image/fireCar.png')
                        }, null, 8, ["src"]),
                        _createVNode("div", null, [
                          _createVNode("img", {
                            src: require('@/assets/image/unionIcon.png'),
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleClick('fire')))
                          }, null, 8, ["src"]),
                          _hoisted_24
                        ])
                      ], 64))
                ]),
                _createVNode("div", _hoisted_25, [
                  (!_ctx.state.isWater)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _createVNode("img", {
                          src: require('@/assets/image/noWaterCar.png')
                        }, null, 8, ["src"]),
                        _createVNode("div", null, [
                          _createVNode("img", {
                            src: require('@/assets/image/unionIcon.png')
                          }, null, 8, ["src"]),
                          _hoisted_26
                        ])
                      ], 64))
                    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        _createVNode("img", {
                          src: require('@/assets/image/waterCar.png')
                        }, null, 8, ["src"]),
                        _createVNode("div", null, [
                          _createVNode("img", {
                            src: require('@/assets/image/unionIcon.png'),
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleClick('water')))
                          }, null, 8, ["src"]),
                          _hoisted_27
                        ])
                      ], 64))
                ])
              ], 64))
        ])
      ])
    ]),
    (_ctx.state.isShowModel)
      ? (_openBlock(), _createBlock(_component_componentModel, {
          key: 0,
          data: _ctx.state.clickData,
          showModel: _ctx.state.isShowModel,
          onParEvn: _ctx.parEvn
        }, null, 8, ["data", "showModel", "onParEvn"]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, _ctx.state.reportLevel !== 4]
  ])
})